import { defineMessages } from 'react-intl'

const scope = `modules.expense.features.revise-expense-report.presenters.ReviseExpenseReportPresenter`

export default defineMessages({
  revisingBadge: {
    id: `${scope}.revisingBadge`,
    defaultMessage: 'Revising',
  },
  deniedBadge: {
    id: `${scope}.deniedBadge`,
    defaultMessage: 'Denied',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Expense report #{id} resubmitted',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: "Expense report couldn't be resubmitted",
  },
  missingDepartmentErrorMessage: {
    id: `${scope}.missingDepartmentErrorMessage`,
    defaultMessage:
      'Please select a {singularSecondaryOrgCategoryLabelLowercase}',
  },
  resubmitButton: {
    id: `${scope}.resubmitButton`,
    defaultMessage: 'Resubmit',
  },
})
